export default "__VITE_PUBLIC_ASSET__e309230c__"